export type TRoleName = 'parent' | 'careProfessional' | 'educator'
export interface IRole {
  title: string
  name: TRoleName
  image: string
}

const roles: IRole[] = [
  {
    title: 'Parent',
    name: 'parent',
    image: require('../../assets/images/role/parent.png')
  },
  {
    title: 'Care Professional',
    name: 'careProfessional',
    image: require('../../assets/images/role/careProfessional.png')
  }
]

export default roles



// WEBPACK FOOTER //
// ./src/components/RoleSelector/roles.ts